import React, { useEffect, useState } from "react";
import { getApi, postApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";
import moment from "moment";

function useLoadMasterDataHome() {
  const [gallery, setGallery] = useState();
  const [masterData, setMasterData] = useState({
    slider: null,
    monthlyNewsletter: null,
    annualCalendar: null,
    latestNews: null,
    spotlight: null,
    services: null,
    liveStreamingUrlData: null,
    dailyPanchangam: null,
    dailyNews: null,
    allEvents: null,
    upcomingEvents: null,
  });

  const getMasterData = async () => {
    const date = moment().tz("America/New_York").format("ddd, DD MMM YYYY ");
    const payload = {
      date,
    };
    const newsPayload = {
      limits: 5,
    };
    const result = await Promise.all([
      getApi(apiEndPoints.getHomePageSliderItems),
      getApi(apiEndPoints.getMonthlyNewsletter),
      getApi(apiEndPoints.getAnnualCalender),
      getApi(apiEndPoints.getHomePageScrollerItems),
      getApi(apiEndPoints.getHomePageSpotlightItems),
      getApi(apiEndPoints.getHomePageServiceCatogryItems),
      getApi(apiEndPoints.getliveStreamingUrl),
      postApi(apiEndPoints.getHomePagePanchang, payload),
      postApi(apiEndPoints.getHomePageLatesNewsItems, newsPayload),
      getApi(apiEndPoints.getHomePageLatesEventItems),
      postApi(apiEndPoints.getHomePageUpcomingEvents),
    ]);

    setMasterData({
      slider: result[0]?.data,
      monthlyNewsletter: result[1]?.data,
      annualCalendar: result[2]?.data,
      latestNews: result[3]?.data,
      spotlight: result[4]?.data,
      services: result[5]?.data?.data,
      liveStreamingUrlData: result[6]?.data?.data[0],
      dailyPanchangam: result[7]?.data?.data,
      dailyNews: result[8]?.data?.data,
      allEvents: result[9]?.data?.data,
      upcomingEvents: result[10]?.data,
    });

    const [galleryList, galleryCategories, galleryFestivals, galleryTags] =
      await Promise.all([
        postApi(apiEndPoints.allGallery, payload),
        getApi(apiEndPoints.galleryCategories),
        getApi(apiEndPoints.galleryFestivals),
        getApi(apiEndPoints.galleryTags),
      ]);

    setGallery({
      list: galleryList?.data?.status == 1 ? galleryList?.data?.data : [],
      categories:
        galleryCategories?.data?.status == 1
          ? galleryCategories?.data?.data
          : [],
      festival:
        galleryFestivals?.data?.status == 1 ? galleryFestivals?.data?.data : [],
      tags: galleryTags?.data?.status == 1 ? galleryTags?.data?.data : [],
    });
  };

  const [todaySchedule, setTodaySchedule] = useState([]);
  const [tab, setTab] = useState("Monthly");
  const [date, setDate] = useState(
    moment().tz("America/New_York").format("YYYY-MM-DD")
  );

  function formatDateForDisplay(date) {
    return moment(date).tz("America/New_York").format("ddd, DD MMM YYYY");
  }
  const updateDate = (days) => {
    const newDate = moment(date).add(days, "days").format("YYYY-MM-DD");
    setDate(newDate);
  };

  const payload = {
    date: date,
  };

  const getSchedule = async () => {
    try {
      const response = await postApi(
        apiEndPoints.getHomePagetodaysPujaSchedule,
        payload
      );
      setTodaySchedule(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  useEffect(() => {
    getSchedule();
  }, [date]);

  return {
    todaySchedule,
    handleChange,
    updateDate,
    formatDateForDisplay,
    tab,
    date,
    masterData,
    getMasterData,
    gallery,
    setMasterData,
  };
}

export default useLoadMasterDataHome;
